/* This file is autogenerated, see readme.md for instructions */
import EducationHubSvgIcon from '@bloomreach/banana-theme/icons/education-hub.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EducationHubIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EducationHubSvgIcon />
    </Icon>
  );
});

EducationHubIcon.displayName = 'EducationHubIcon';

export default EducationHubIcon;
